import { buildHead } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";
import AdminLayout from "@/pages/admin/AdminLayout";

export const Route = createFileRoute("/_app/admin")({
  head: () =>
    buildHead({
      title: "Admin Console | LohaLink",
      description: "Internal LohaLink operations console.",
      canonical: "/admin",
      noindex: true,
    }),
  component: () => <AdminLayout />,
});
